<div class="d-flex mb-4 justify-content-between">
  <button class="btn btn-primary my-2 my-sm-0" type="button"><strong>+</strong> {{title}}</button>
</div>